var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpotSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spot_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spot_selected",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.237188593,
    stroke: "#BD10E0",
    strokeWidth: 2,
    fillOpacity: 0.249098558,
    fill: "#FFFFFF",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.237188593,
    fill: "#BD10E0",
    cx: 25,
    cy: 25,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3671875,33.9208984 C21.7578125,33.9208984 22.1337891,33.8452148 22.4951172,33.6938477 C22.8564453,33.5424805 23.1738281,33.3300781 23.4472656,33.0566406 L23.4472656,33.0566406 L35.078125,21.4111328 C35.3515625,21.1376953 35.5615234,20.8203125 35.7080078,20.4589844 C35.8544922,20.0976562 35.9277344,19.7216797 35.9277344,19.3310547 C35.9277344,18.9208984 35.8520508,18.5375977 35.7006836,18.1811523 C35.5493164,17.824707 35.3417969,17.5146484 35.078125,17.2509766 C34.8144531,16.9873047 34.5043945,16.7797852 34.1479492,16.628418 C33.7915039,16.4770508 33.4082031,16.4013672 32.9980469,16.4013672 C32.6074219,16.4013672 32.2314453,16.4746094 31.8701172,16.6210938 C31.5087891,16.7675781 31.1914062,16.9775391 30.9179688,17.2509766 L30.9179688,17.2509766 L21.3671875,26.8164062 L18.1445312,23.59375 C17.8710938,23.3203125 17.5537109,23.1103516 17.1923828,22.9638672 C16.8310547,22.8173828 16.4550781,22.7441406 16.0644531,22.7441406 C15.6542969,22.7441406 15.2709961,22.8198242 14.9145508,22.9711914 C14.5581055,23.1225586 14.2480469,23.3300781 13.984375,23.59375 C13.7207031,23.8574219 13.5107422,24.1674805 13.3544922,24.5239258 C13.1982422,24.8803711 13.1201172,25.2636719 13.1201172,25.6738281 C13.1201172,26.0644531 13.1958008,26.4404297 13.347168,26.8017578 C13.4985352,27.1630859 13.7109375,27.4804688 13.984375,27.7539062 L13.984375,27.7539062 L19.2871094,33.0566406 C19.5605469,33.3300781 19.8779297,33.5424805 20.2392578,33.6938477 C20.6005859,33.8452148 20.9765625,33.9208984 21.3671875,33.9208984 Z",
    id: "f",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#5B4358",
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotSelected);
export default __webpack_public_path__ + "static/media/spot_selected.5b3e82bbb5288346828d71278bf7906b.svg";
export { ForwardRef as ReactComponent };